import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';

Vue.use(VueCompositionAPI);

import FaqList from "./components/FaqList";

const faqsthing = new Vue({
    el   : '#faqspage',
    props: {},
    components: {
        FaqList
    },
    data() {
        return {};
    },
    mounted() {
    }
});
